import './../../../node_modules/normalize.css/normalize.css';
import './../../../node_modules/@blueprintjs/core/dist/blueprint.css';
import './../../../node_modules/@blueprintjs/datetime/dist/blueprint-datetime.css';
import './../../../node_modules/tachyons/css/tachyons.min.css';
import './../../../node_modules/animate.css/animate.min.css';
import './../../../node_modules/react-select/dist/react-select.min.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider, observer, inject } from 'mobx-react';
import { SectionManager } from './pages/SectionManager';
import { AppStore } from '../../common/stores/AppStore';
import { getEnv, types } from 'mobx-state-tree';
import { EntityModel, ListStore } from '../../utils/stores';
import { Registration } from './services/Registration';
import client from './client';

export const Store = types.model('Store', {
  app: AppStore,
  registration: types.optional(EntityModel(Registration), {}),
  registrations: types.optional(ListStore(Registration), {}),
  authenticated: false,

  get client() {
    return getEnv(this).client;
  }
}, {
  setAuthenticated() {
    this.authenticated = true;
  },
  setUnAuthenticated() {
    this.authenticated = false;
  }
});

const bootstrap = () => Promise.resolve(Store.create({
  app: {
    name: 'BamosBD',
    view: {
      roles: {
        anon: {
          routes: {
            landing: {
              name: 'landing',
              path: '/'
            },
            preConference: {
              name: 'preConference',
              path: '/preConference'
            },
            eventpaymentpage: {
              name: 'eventpaymentpage',
              path: '/eventpaymentpage'
            },
            cancellationOrRefund: {
              name: 'cancellationOrRefund',
              path: '/cancellationOrRefund'
            },
            venue: {
              name: 'venue',
              path: '/venue'
            },
            postConferenceTour: {
              name: 'postConferenceTour',
              path: '/postConferenceTour'
            },
            accommodation: {
              name: 'accommodation',
              path: '/accommodation'
            },
            contactUs: {
              name: 'contactUs',
              path: '/contactUs'
            },
            sponsor: {
              name: 'sponsor',
              path: '/sponsor'
            },
            eventsWorkshop: {
              name: 'eventsWorkshop',
              path: '/eventsWorkshop'
            },
            admin: {
              name: 'admin',
              path: '/admin'
            }
          },
          currentRoute: 'landing',
          name: 'anon'
        }
      },
      currentRole: 'anon'
    }
  }
}, { client })).then(store => {
  if (process.env.NODE_ENV === 'development') {
    // tslint:disable-next-line:no-any
    (window as any).store = store;
  }
  ReactDOM.render(
    <Provider store={store}>
      <AppComponent />
    </Provider>,
    document.getElementById('root') as HTMLElement);
});

const AppComponent = inject('store')(observer(() => (
  <main className="w-100 v-100">
    <SectionManager />
  </main>
)));

bootstrap();


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/index.tsx